/* tslint:disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum FeatureFlagType {
    
        Travel = 1,
    
        RPU = 2,

        TravelItinerary = 6
    
}